import Layout from "components/Layout";
import GroupAddForm from "./Components/GroupAddForm";
import React from "react";

function AdminGroupAddPage() {
  return (
    <Layout title="그룹 등록">
      <GroupAddForm />
    </Layout>
  );
}

export default AdminGroupAddPage;
